import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-success",
  "use": "icon-success-usage",
  "viewBox": "0 0 72 72",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 72 72\" id=\"icon-success\"><g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M36 0C16.118 0 0 16.118 0 36s16.118 36 36 36 36-16.118 36-36S55.882 0 36 0z\" fill=\"#008BFE\" /><path d=\"M57.341 25.572s-26.338 24.71-26.346 24.716a1.504 1.504 0 01-2.12-.027l-13.45-13.273a1.504 1.504 0 01.026-2.12 1.504 1.504 0 012.121.026l12.385 12.197 25.29-23.667a1.504 1.504 0 012.12.027 1.503 1.503 0 01-.026 2.121z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol